import { useTranslation } from "react-i18next";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";

export const RenderItem = ({ title, label, newStatus = null, oldStatus = null, oldValue, newValue }) => {
    const { t } = useTranslation();

    return (
        <>
            {title && (
                <h4 className="my-2 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>
                    {t(title)}
                </h4>
            )}
            <div className="py-2">
                {typeof oldStatus === "boolean" || typeof newStatus === "boolean" ? (
                    <span className="font-weight-bold">{t("status")}: </span>
                ) : null}
                {typeof oldStatus === "boolean" && <OldValue value={oldStatus ? t("active") : t("not-active")} />}
                {typeof newStatus === "boolean" && <NewValue value={newStatus ? t("active") : t("not-active")} />}
            </div>
            <div>
                <Label value={t(label)} /> {oldValue && <OldValue value={oldValue} />}
                {newValue !== null && <NewValue value={newValue} />}
            </div>
        </>
    );
};
